import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HOTEL_QUERY } from "./schema";

export const useHotelQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(HOTEL_QUERY, { variables: { hotelID } });

	return {
		data,
	};
};
